<div id="regiaoCidadeSubRegioes" class="modal fade" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        Sub-regiões
                    </h4>        
                </div>
                <div class="modal-body">
                   <form #form="ngForm" novalidate>
                       <div class="row" *ngIf="regiaoCidade">
                           <div class="col-12">
                                <div *ngIf="regiaoCidade.subRegioes.length === 0" class="alert alert-info text-center" role="alert">
                                    <p><i class='fas fa-info' aria-hidden='true'></i> A cidade não possui nenhuma sub-região cadastrada. Acesse o cadastro da cidade para adicioar suas sub-regiões e bairros</p>    
                                </div> 

                                <div class="card card-sub-regiao" *ngFor="let entity of regiaoCidade.subRegioes; let i = index">
                                    <div class="card-header" *ngIf="entity">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.isChecked" name="subRegiaoChecked_{{i}}" id="subRegiaoChecked_{{i}}"
                                                (change)="onChangeCheckSubRegiao(entity)">
                                            <label class="custom-control-label" for="subRegiaoChecked_{{i}}">{{entity.cidadeSubRegiao.nome}}</label>
                                        </div>                                           
                                    </div>                                 
                                    <!-- Bairros -->
                                    <ul class="list-group list-group-flush list-group-bairros">
                                        <li class="list-group-item" *ngFor="let bairro of entity.bairros; let j = index">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" [(ngModel)]="bairro.isChecked" name="bairroChecked__{{i}}_{{j}}" id="subRegiaoChecked__{{i}}_{{j}}"
                                                    (change)="onChangeCheckBairro(entity)">
                                                <label class="custom-control-label" for="subRegiaoChecked__{{i}}_{{j}}">{{bairro.cidadeSubRegiaoBairro.nome}}</label>
                                            </div>                                          
                                        </li>
                                    </ul>
                                </div>                                                               
                            </div>
                        </div>
                   </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" (click)="close()">
                        Ok
                    </button>
                </div>            
            </div>
        </div>
    </div>